import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const PROMOTIONS_API_PATH = '/api/promotions';

const getPromotions = async (params = {}) => {
  const response = await axios.get(`${API_BASE_URL}${PROMOTIONS_API_PATH}`, { params });
  return response.data.data;
};

const getActivePromotions = async (storeId) => {
  return getPromotions({ storeId, activeOnly: true });
};

const createPromotion = async (promoData) => {
  const response = await axios.post(`${API_BASE_URL}${PROMOTIONS_API_PATH}`, promoData);
  return response.data.data;
};

// --- NEW FUNCTIONS ---
const updatePromotion = async (id, promoData) => {
  const response = await axios.put(`${API_BASE_URL}${PROMOTIONS_API_PATH}/${id}`, promoData);
  return response.data.data;
};

const deletePromotion = async (id) => {
  await axios.delete(`${API_BASE_URL}${PROMOTIONS_API_PATH}/${id}`);
  return id;
};

const promotionsService = {
  getPromotions,
  getActivePromotions,
  createPromotion,
  updatePromotion, // <-- Add
  deletePromotion, // <-- Add
};

export default promotionsService;
